export const ADD_NOMINEE = 'Add Nominee';
export const NOMINEE = 'Nominee Name';
export const NOMINEE_TYPE = 'Nominee Type';
export const MAIL = 'Mailing/E-mail address of the nominee';
export const RELATIONSHIP = 'Nominee is your';
export const DOCUMENT = 'Personal Identifiers of the nominee';
export const ENTER_NAME = 'Enter Name';
export const ENTER_MAIL = 'Enter e-mail address';
export const DATE_OF_BIRTH = 'Date of Birth';
export const SHARE = 'Share';
export const MOBILE_NO = 'Mobile Number of the nominee';
export const CITY = 'City';
export const ADDRESS = 'Address of the nominee';
export const pinCode = 'PinCode';
export const Country = 'Country';
export const DOC_No = 'Document Number';
export const ADD_ANOTHER_NOMINEE = 'Add Another Nominee';
export const CHECKBOX_MESSAGE = 'Make this as my default nominee';
export const CONFIRM_DETAILS = 'Confirm Details';
export const CONFIRM = 'Confirm';
export const GUARDIAN = 'Guardian';
export const MINOR = 'Minor';
export const ENTER_GUARDIAN_NAME = 'Enter Guardian Name';
export const FREQUENCY_VALUE = [
  {
    label: 'FATHER',
    value: 'FATHER',
  },
  {
    label: 'BROTHER',
    value: 'BROTHER',
  },
  {
    label: 'DAUGHTER',
    value: 'DAUGHTER',
  },
  {
    label: 'AUNT',
    value: 'AUNT',
  },
  {
    label: 'BENEFICIAL OWNER',
    value: 'BENEFICIAL OWNER',
  },
  {
    label: 'CO-PARCENER',
    value: 'CO-PARCENER',
  },
  {
    label: 'GRAND DAUGHTER',
    value: 'GRAND DAUGHTER',
  },
  {
    label: 'GRAND FATHER',
    value: 'GRAND FATHER',
  },
];
